'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = init;

var _request = require('@shopify/theme-cart/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var _this = this;

  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    triggers: context.getElements('.' + context.className + '_Trigger'),
    inputs: context.getElements('.js-QuantityAdjuster_Input'),
    giftWrapSelect: context.getElements('.' + context.className + '_GiftWrapSelector')
  };

  var cart = (0, _request.cart)();

  els.giftWrapSelect.forEach(function (selector) {
    selector.addEventListener('change', function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
        var selector, key, currentItem, propertiesToAdd, quantityToAdd, variantToAdd;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true, el);

                selector = event.currentTarget;
                key = selector.dataset.lineItemKey;
                _context.next = 5;
                return cart;

              case 5:
                _context.t0 = function (item) {
                  return item.key === key;
                };

                currentItem = _context.sent.items.find(_context.t0);
                propertiesToAdd = (0, _assign2.default)({}, currentItem.properties);
                quantityToAdd = currentItem.quantity;
                variantToAdd = selector.value;

                // cartChange utility doesn't support passing an id/key, instead accepting a line number

                _context.next = 12;
                return fetch('/cart/change.js', {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json;'
                  },
                  body: (0, _stringify2.default)({
                    id: key,
                    quantity: 0
                  })
                });

              case 12:
                _context.next = 14;
                return (0, _request.cartAdd)(variantToAdd, quantityToAdd, propertiesToAdd);

              case 14:

                window.location.reload();

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  });

  els.triggers.forEach(function (el) {
    el.addEventListener('click', function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var values;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading(true, el);

                values = els.inputs.map(function (el) {
                  return el.value;
                });
                _context2.next = 4;
                return (0, _request.cartUpdate)({
                  updates: values
                });

              case 4:

                window.location.reload();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
  });

  function setLoading(isLoading, el) {
    el.classList.toggle('crt-Products_Update-loading', isLoading);
  }
}